import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';

const userProperties = {
  title: PropTypes.string.isRequired,
};

type UserProperties = PropTypes.InferProps<typeof userProperties> & {
  fillColor?: string;
};

const User = ({
  title,
  fillColor = 'var(--grey-dark)',
  ...properties
}: UserProperties) => (
  <Icon
    // eslint-disable-next-line max-len
    dPath="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
    title={title}
    fill={fillColor}
    {...properties}
  />
);

User.propTypes = userProperties;

export default User;
